export const LoadMoreOnScroll = {
  mounted() {
    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          this.pushEvent("load_more", {});
        }
      },
      {
        root: null,
        rootMargin: "0px 0px 300px 0px",
        threshold: 0.1,
      },
    );

    observer.observe(this.el);
  },
};
